import { GET_ADDFAQ_REQUESTED, GET_DELETEFAQ_REQUESTED, GET_FAQ_REQUESTED, GET_FAQ_SECTION_REQUESTED, GET_UPDATEFAQ_REQUESTED } from "resources/actionTypes";

export function getFaq(filterData) {
  const data ={
    id:filterData.id,
    role:filterData.role,
  }
  return {
    type: GET_FAQ_REQUESTED,
    payload:data
  };
}

export function postAddFaq(userAddFaq) {
  const data ={
    userAddFaq:userAddFaq,
  }
  return {
    type: GET_ADDFAQ_REQUESTED,
    payload: data,
  };
}

export function patchUpdateFaq(userUpdateFaq) {
  const data ={
    userUpdateFaq:userUpdateFaq,
  }
  return {
    type: GET_UPDATEFAQ_REQUESTED,
    payload: data,
  };
}

export function deleteFaq(userDeleteFaq) {
  const data ={
    userDeleteFaq:userDeleteFaq,
  }
  return {
    type: GET_DELETEFAQ_REQUESTED,
    payload: data,
  };
}
export function getFaqSection(){
  
  return {
      type: GET_FAQ_SECTION_REQUESTED
  };

}
